import { useApiUtils } from '@core/util/apiUtils';
import { usuarioApi } from 'app/services/api/usuarioApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext';
import { eventReactGA } from 'app/utils/analyticsUtil';
import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import TelaBloqueio from '../../components/TelaBloqueio';
import { ValidacaoClienteModais } from '../../ValidacaoClienteModais';

const ModalClienteBloqueado = () => {
  const [modalValidacaoCliente, setModalValidacaoCliente] = useContext(GlobalContext).modalValidacaoCliente;
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const solicitarDesbloqueio = async () => {
    try {
      setLoading(true);
      eventReactGA('Usuário', 'Solicitar desbloqueio de acesso ao sistema');
      await usuarioApi.solicitarDesbloqueio();
      setModalValidacaoCliente(ValidacaoClienteModais.modalDesbloqueioSolicitado);
    } catch (error) {
      apiUtils.handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <TelaBloqueio
      open={modalValidacaoCliente === ValidacaoClienteModais.modalClienteBloqueado}
      mensagem={
        <>
          Foram identificadas pendências financeiras em sua conta. Acione a opção abaixo para solicitar desbloqueio ou
          entre em contato com o setor de atendimento para maiores informações.
        </>
      }
      botaoAdicional={{ label: 'Solicitar desbloqueio', onClick: solicitarDesbloqueio }}
      loading={loading}
    />
  );
};

export default ModalClienteBloqueado;
